/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type NotificationType =
  | 'DOCUMENT_SHARED'
  | 'ACCESS_GRANTED'
  | 'PORTAL_ACTIVITY'
  | 'PAYMENT_FAILED'
  | 'INVOICE_UNPAID'
  | 'SUBSCRIPTION_CANCELLATION_REQUESTED'
  | unhandledEnumCase;

export type PortalInstanceType =
  | 'CUSTOMER'
  | 'BUYER'
  | 'BILLING'
  | 'REFERENCE'
  | 'CUSTOMER_SUCCESS'
  | 'DEAL_PLAN'
  | 'UNIVERSAL'
  | 'QUOTE'
  | 'WORK'
  | 'CUSTOM'
  | 'HOME_APP'
  | unhandledEnumCase;

export const ConsentErrorTypename =
  'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export type ConsentError = {
  reason: ConsentErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.ConsentError';
} & { '@type'?: 'CONSENT' };

export const CustomerSuccessPortalErrorTypename =
  'com.hubspot.portals.platform.models.rpc.CustomerSuccessPortalError';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export type CustomerSuccessPortalError = {
  reason: CustomerSuccessPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.CustomerSuccessPortalError';
} & { '@type'?: 'CUSTOMER_SUCCESS_PORTAL' };

export type DeleteNotificationRequest = {
  notificationId: number;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type DeleteNotificationResponse = {};

export const FileErrorTypename =
  'com.hubspot.portals.platform.models.rpc.FileError';
export const FileErrorDiscriminant = 'FILE';
export const FileErrorDiscriminantKey = '@type';
export type FileError = {
  reason: FileErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.FileError';
} & { '@type'?: 'FILE' };

export type GetPortalNotificationsRequest = {
  offset: number;
  limit: number;
  portalInstanceType?: PortalInstanceType;
  notificationType?: NotificationType;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type GetPortalNotificationsResponse = {
  notifications: Default<PortalNotificationResponse[]>;
  totalCount: number;
  unreadCount: number;
};

export const HomeFeedErrorTypename =
  'com.hubspot.portals.platform.models.rpc.HomeFeedError';
export const HomeFeedErrorDiscriminant = 'HOME_FEED';
export const HomeFeedErrorDiscriminantKey = '@type';
export type HomeFeedError = {
  reason: HomeFeedErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.HomeFeedError';
} & { '@type'?: 'HOME_FEED' };

export type MarkAllNotificationsAsReadRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type MarkAllNotificationsAsReadResponse = { updatedCount: number };

export type MarkNotificationAsReadRequest = {
  notificationId: number;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type MarkNotificationAsReadResponse = {};

export const NotificationErrorTypename =
  'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export type NotificationError = {
  reason: NotificationErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.NotificationError';
} & { '@type'?: 'NOTIFICATION' };

export const PortalAuthErrorTypename =
  'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export type PortalAuthError = {
  reason: PortalAuthErrorReason;
  portalInstanceId?: number;
  denialReason?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
} & { '@type'?: 'AUTH' };

export type PortalNotificationResponse = {
  id: number;
  portalInstanceId: number;
  notificationType: NotificationType;
  title: string;
  body: string;
  ctaLink?: string;
  createdAt: number;
  isRead: boolean;
};

export const PortalPublicRpcErrorDiscriminantKey = '@type';
export type PortalPublicRpcError =
  | PortalAuthError
  | NotificationError
  | ConsentError
  | SettingsError
  | SupportPortalError
  | TranslationsError
  | TrackEventError
  | CustomerSuccessPortalError
  | FileError
  | SalesDocumentError
  | SpaceAccessResolverError
  | HomeFeedError;

export const SettingsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export type SettingsError = {
  reason: SettingsErrorReason;
  passwordErrors: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SettingsError';
} & { '@type'?: 'SETTINGS' };

export const SupportPortalErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export type SupportPortalError = {
  reason: SupportPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
} & { '@type'?: 'SUPPORT_PORTAL' };

export const TrackEventErrorTypename =
  'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export type TrackEventError = {
  reason: TrackEventErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.TrackEventError';
} & { '@type'?: 'TRACK_EVENT' };

export type ConsentErrorReason =
  | 'CONSENT_LABELS_NOT_FOUND'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type CustomerSuccessPortalErrorReason =
  | 'ONBOARDING_PLAN_NOT_FOUND'
  | 'TASK_NOT_FOUND'
  | 'RESOURCE_NOT_FOUND'
  | 'INVALID_REQUEST'
  | unhandledEnumCase;

export type FileErrorReason =
  | 'FILE_NOT_FOUND'
  | 'FILE_ALREADY_DELETED'
  | 'ACCESS_DENIED'
  | 'CONTACT_NOT_FOUND'
  | 'DUPLICATE_FILE'
  | 'INVALID_FILE'
  | 'INVALID_REQUEST'
  | 'PORTAL_ID_REQUIRED'
  | 'USER_ID_REQUIRED'
  | 'FILE_MANAGER_ERROR'
  | 'SPACE_ACCESS_RESOLVER_ERROR'
  | 'PDF_CONVERSION_PENDING'
  | unhandledEnumCase;

export type HomeFeedErrorReason =
  | 'VIEWER_NOT_IDENTIFIED'
  | 'ITEM_NOT_FOUND'
  | unhandledEnumCase;

export type NotificationErrorReason =
  | 'NOTIFICATION_NOT_FOUND'
  | 'INVALID_NOTIFICATION_TYPE'
  | 'MISSING_PORTAL_ID'
  | 'INVALID_NOTIFICATION_NAME'
  | 'INVALID_TARGET'
  | 'PORTAL_INSTANCE_NOT_FOUND'
  | 'HUBSPOT_NOTIFICATION_SEND_FAILED'
  | unhandledEnumCase;

export type PortalAuthErrorReason =
  | 'AUTHENTICATION_FAILED'
  | 'ACCESS_DENIED'
  | 'UNEXPECTED_ERROR'
  | 'INVALID_PARAMETER_COUNT'
  | 'INVALID_PARAMETER_TYPES'
  | 'MISSING_ACCOUNT_ID'
  | 'MISSING_PORTAL_INSTANCE_ID'
  | 'MISSING_MEMBERSHIP_COOKIE'
  | 'EMPTY_MEMBERSHIP_COOKIE'
  | 'CSRF_ERROR'
  | 'MISSING_CRM_OBJECT_ID'
  | 'MISSING_CRM_OBJECT_ASSOCIATION'
  | 'FORM_NOT_FOUND'
  | 'WRONG_HUBLET'
  | 'PORTAL_INSTANCE_ACCESS_DENIED'
  | unhandledEnumCase;

export type SettingsErrorReason =
  | 'MISSING_REQUIRED_FIELD'
  | 'CONTACT_NOT_FOUND'
  | 'FILE_TOO_LARGE'
  | 'UNSUPPORTED_FILE_TYPE'
  | 'WRONG_CURRENT_PASSWORD'
  | 'INVALID_PASSWORD'
  | 'SAME_PASSWORD'
  | 'PASSWORD_LEAKED'
  | 'PASSWORDS_DO_NOT_MATCH'
  | 'CURRENT_PASSWORD_REQUIRED'
  | 'INVALID_PREFERRED_LANGUAGE'
  | 'FIELD_TOO_LONG'
  | 'PROFILE_EDITING_DISABLED'
  | 'RATE_LIMITED'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type SupportPortalErrorReason =
  | 'SETTINGS_NOT_FOUND'
  | 'TICKET_NOT_FOUND'
  | 'THREAD_NOT_FOUND'
  | 'CONTACT_NOT_FOUND'
  | 'RESOURCE_NOT_FOUND'
  | 'INVALID_MESSAGE_PUBLISH'
  | 'INVALID_TICKET_ACTION'
  | 'INVALID_REQUEST'
  | unhandledEnumCase;

export type TrackEventErrorReason = 'EVENT_NOT_TRACKABLE' | unhandledEnumCase;

export const SpaceAccessResolverErrorTypename =
  'com.hubspot.portals.platform.models.rpc.resolver.SpaceAccessResolverError';
export const SpaceAccessResolverErrorDiscriminant = 'SPACE_ACCESS_RESOLVER';
export const SpaceAccessResolverErrorDiscriminantKey = '@type';
export type SpaceAccessResolverError = {
  reason: SpaceAccessResolverErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.resolver.SpaceAccessResolverError';
} & { '@type'?: 'SPACE_ACCESS_RESOLVER' };

export type SpaceAccessResolverErrorReason =
  | 'RESOLVER_ERROR'
  | 'RESOLVER_TIMEOUT'
  | 'RESOLVER_UNAVAILABLE'
  | unhandledEnumCase;

export const SalesDocumentErrorTypename =
  'com.hubspot.portals.platform.models.rpc.salesdocuments.SalesDocumentError';
export const SalesDocumentErrorDiscriminant = 'SALES_DOCUMENT';
export const SalesDocumentErrorDiscriminantKey = '@type';
export type SalesDocumentError = {
  reason: SalesDocumentErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.salesdocuments.SalesDocumentError';
} & { '@type'?: 'SALES_DOCUMENT' };

export type SalesDocumentErrorReason =
  | 'SALES_DOCUMENT_NOT_FOUND'
  | 'DUPLICATE_SALES_DOCUMENT'
  | 'INVALID_REQUEST'
  | 'MISSING_PORTAL_ID'
  | 'MISSING_USER_ID'
  | 'SHARE_LINK_GENERATION_FAILED'
  | 'SPACE_ACCESS_RESOLVER_ERROR'
  | 'CONTACT_RESOLUTION_FAILED'
  | 'ACCESS_DENIED'
  | unhandledEnumCase;

export const TranslationsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export type TranslationsError = {
  reason: TranslationsErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
} & { '@type'?: 'TRANSLATIONS' };

export type TranslationsErrorReason =
  | 'MISSING_LOCALE'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type GetNotificationsRequestType =
  Requestify<GetPortalNotificationsRequest>;
export type GetNotificationsResponseType = GetPortalNotificationsResponse;
export type GetNotificationsErrorType = PortalPublicRpcError & HubspotMetadata;
export const getNotificationsRpc: ChirpAvroRpcDetails<
  GetNotificationsRequestType,
  GetNotificationsResponseType,
  GetNotificationsErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'getNotifications',
  auth: 'external',
  fingerprint: 'Rsw79Feu4ZbRjbBtHEnLIZpZAL1fkDof',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type MarkNotificationAsReadRequestType =
  Requestify<MarkNotificationAsReadRequest>;
export type MarkNotificationAsReadResponseType = MarkNotificationAsReadResponse;
export type MarkNotificationAsReadErrorType = PortalPublicRpcError &
  HubspotMetadata;
export const markNotificationAsReadRpc: ChirpAvroRpcDetails<
  MarkNotificationAsReadRequestType,
  MarkNotificationAsReadResponseType,
  MarkNotificationAsReadErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'markNotificationAsRead',
  auth: 'external',
  fingerprint: 'x-2QffrKNOl8cyWpNBt5O5pZAL1fkDof',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type MarkAllNotificationsAsReadRequestType =
  Requestify<MarkAllNotificationsAsReadRequest>;
export type MarkAllNotificationsAsReadResponseType =
  MarkAllNotificationsAsReadResponse;
export type MarkAllNotificationsAsReadErrorType = PortalPublicRpcError &
  HubspotMetadata;
export const markAllNotificationsAsReadRpc: ChirpAvroRpcDetails<
  MarkAllNotificationsAsReadRequestType,
  MarkAllNotificationsAsReadResponseType,
  MarkAllNotificationsAsReadErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'markAllNotificationsAsRead',
  auth: 'external',
  fingerprint: 'YlZ7t7iQQLdgJzATZQbQ-ppZAL1fkDof',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteNotificationRequestType =
  Requestify<DeleteNotificationRequest>;
export type DeleteNotificationResponseType = DeleteNotificationResponse;
export type DeleteNotificationErrorType = PortalPublicRpcError &
  HubspotMetadata;
export const deleteNotificationRpc: ChirpAvroRpcDetails<
  DeleteNotificationRequestType,
  DeleteNotificationResponseType,
  DeleteNotificationErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'deleteNotification',
  auth: 'external',
  fingerprint: 'dqP94nA66ZrqVVRLWEljJppZAL1fkDof',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
